module.exports = __webpack_public_path__ + "img/dice-1.532ad4d3.png";